import type React from "react";
import { useState } from "react";

import MyInfoBlockDesktop from "@/base/blocks/MyInfoBlock/MyInfoBlockDesktop";
import MyInfoBlockMobile from "@/base/blocks/MyInfoBlock/MyInfoBlockMobile";
import { Row } from "@/base/components/Layout";
import ApolloClubCardModal from "@/base/components/Modal/ApolloClubCardModal";
import { createUseStyles } from "@/theme";

export type MyInfoBlockProps = {
  mobile?: {
    showCard?: boolean;
    fullProfile?: boolean;
    minimal?: boolean;
  };
  desktop?: {
    showCard?: boolean;
    minimal?: boolean;
  };
  title?: string;
  subTitle?: string;
};

export const useMyInfoBlockStyles = createUseStyles(({ color, spacing }) => ({
  wrapperDesktop: {
    paddingBottom: spacing.l,
    paddingTop: spacing.x4l + spacing.m,
  },
  wrapperMobile: {
    paddingTop: spacing.xxl,
    marginBottom: spacing.xl,
    paddingLeft: spacing.xl,
    paddingRight: spacing.xl,
  },
  linksContainer: {
    gap: spacing.l,
    borderLeft: `1px solid transparent`, // Prevent layout shift
  },
  linksContainerBorder: {
    borderLeft: `1px solid ${color.gray5}`,
  },
  links: {
    paddingLeft: spacing.xxl,
  },
  infoCol: {
    alignItems: "start",
    paddingLeft: spacing.xxl,
    paddingRight: spacing.xxl,
  },
  nameWrapper: {
    gap: spacing.m,
    marginBottom: spacing.l,
  },
  qrImageContainer: {
    transition: "transform 0.15s ease-out",
    cursor: "pointer",
    paddingTop: spacing.xxl,
    "@media (hover: hover)": {
      "&:hover": {
        transform: "scale(1.04)",
      },
    },
  },
}));

const MyInfoBlock: React.FC<MyInfoBlockProps> = ({
  mobile,
  desktop,
  title,
  subTitle,
}) => {
  const [shouldShowCardModal, setShouldShowCardModal] = useState(false);
  const openCardModal = () => setShouldShowCardModal(true);
  const mobileProps = mobile ?? {};
  const desktopProps = desktop ?? {};

  return (
    <Row noMarginLeft noMarginRight>
      <ApolloClubCardModal
        isOpen={shouldShowCardModal}
        onClose={() => {
          setShouldShowCardModal(false);
        }}
        onNavigate={() => setShouldShowCardModal(false)}
      />
      <Row belowSm noMargin>
        <MyInfoBlockMobile
          title={title}
          subTitle={subTitle}
          showCard={mobileProps.showCard}
          fullProfile={mobileProps.fullProfile}
          minimal={mobileProps.minimal}
          openCardModal={openCardModal}
        />
      </Row>
      <Row aboveMd noMargin>
        <MyInfoBlockDesktop
          showCard={desktopProps.showCard}
          hasEdit={!desktopProps.minimal}
          openCardModal={openCardModal}
        />
      </Row>
    </Row>
  );
};

export default MyInfoBlock;
